import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import usePageTitle from '../hooks/usePageTitle';

const Status = () => {
  usePageTitle('Statut du service');
  return (
    <div className="min-h-screen flex flex-col bg-gray-100 dark:bg-gray-900 text-black dark:text-white">
      <Header />
      <div className="flex-1 container mx-auto py-8 px-4">
        <h1 className="text-2xl font-bold mb-4">Statut du service</h1>
        <p className="mb-4">Page de transparence technique : incidents récents, disponibilité, maintenance planifiée.</p>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-4">Dernière MAJ : modification du footer — 12/11/25</p>

        <p className="mt-6"><Link to="/" className="text-accent underline">Retour à l'accueil</Link></p>
      </div>
      <Footer />
    </div>
  );
};

export default Status;
